export function render(target, html) {
    const range = document.createRange();
    range.setStart(target, 0);
    target.appendChild(
        range.createContextualFragment(html)
    );
}

export function elementHoehe(element) {
    const elementStyle = element.currentStyle || window.getComputedStyle(element);
    const hoehe = element.scrollHeight;
    const margin = parseFloat(elementStyle.marginTop) + parseFloat(elementStyle.marginBottom);
    const padding = parseFloat(elementStyle.paddingTop) + parseFloat(elementStyle.paddingBottom);
    const border = parseFloat(elementStyle.borderTopWidth) + parseFloat(elementStyle.borderBottomWidth);
    return hoehe + margin + padding + border;
}

export function elementBreite(element, withPadding = true) {
    const elementStyle = element.currentStyle || window.getComputedStyle(element);
    const breite = element.offsetWidth;
    const margin = parseFloat(elementStyle.marginLeft) + parseFloat(elementStyle.marginRight);
    const padding = parseFloat(elementStyle.paddingLeft) + parseFloat(elementStyle.paddingRight);
    const border = parseFloat(elementStyle.borderLeftWidth) + parseFloat(elementStyle.borderRightWidth);
    if (withPadding) return breite + margin + padding + border;
    else return breite + margin + border;
}

export /**
* Der IE ignoriert in vielen Fällen die media-queries im CSS der Komponenten.
* Um das Problem zu lösen, kopieren wir den <link> Tag aus der Komponente in den <head>
* @param {object} customElement - das CustomElement, dessen <link> Knoten aus dem <body> in den <head> kopiert werden soll
*/
function linkAusBodyInHeadVerschieben(customElement) {
   const linkOrigin = customElement.querySelector('LINK');
   const link = document.createElement('LINK');
   link.rel = "stylesheet";
   link.href = linkOrigin.href;
   if (document.head.querySelector(`link[href="${linkOrigin.href}"]`) === null) document.head.appendChild(link);
   if (linkOrigin.parentNode) linkOrigin.parentNode.removeChild(linkOrigin);
}
